module.exports = __webpack_public_path__ + "static/media/Armoires & Wardrobes.c4ea5e25.webp";